import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UrlConnectionEnum } from "../../enums/connection/url-connection.enum";
import { ModelLocatorService } from "../config/model-locator.service";
import { HttpService } from "../http-service/http.service";

@Injectable()
export class BannerService {

    constructor(private httpService: HttpService,
        private modelLocator: ModelLocatorService,
        private router: Router) { }

    /**
     * Gets all posts
     * @author Starley Cazorla
     * @param segmentacao
     * @returns
     */
    async getAllBanners(segmentacao: any) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.post(UrlConnectionEnum.GET_ALL_BANNERS, segmentacao, config).subscribe(
                    {
                        next: (data) => {
                            if (data['status'] == 200) {
                                resolve(data['result']);
                            }
                        },
                        error: (error) => {
                            if (error['status'] == 401) {
                                alert(error.error.message);
                                this.modelLocator.logado = false;
                                localStorage.clear();
                                this.modelLocator.urlretorno = '';
                                this.router.navigate(['/login']);
                            }
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }


}
